import { render } from "./TheNotificationArea.vue?vue&type=template&id=df1f4882&scoped=true&ts=true"
import script from "./TheNotificationArea.vue?vue&type=script&lang=ts"
export * from "./TheNotificationArea.vue?vue&type=script&lang=ts"

import "./TheNotificationArea.vue?vue&type=style&index=0&id=df1f4882&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df1f4882"]])

export default __exports__